<template>
  <div>
    <p>{{ isCreateCustomer ? 'Vui lòng chọn nhu cầu test đầu vào' : 'Vui lòng chọn đúng nhu cầu kiểm tra đầu vào:' }}</p>
    <div>
      <el-radio v-model="radio1" :label="0">Đặt lịch test speaking với admin test (gồm cả bài test general)
      </el-radio>
    </div>
    <div class="mt-2" >
      <el-radio v-model="radio1" :label="1">Đặt lịch test speaking với AI (gồm cả bài test general) <span class="bg-danger p-1 rounded text-white">Hình thức mới</span>
      </el-radio>
    </div>
    <div v-if="+radio1 === 1" :class="+radio1 === 1 ? 'col-span-2' : 'col-span-1'">
      <div>
        <el-select v-model="center_id" filterable class="w-100" placeholder="Chọn trung tâm">
          <el-option v-for="item in centersTestInput" :key="item.id" :label="item.name" :value="item.id">
            <span style="float: left">{{ item.name }}</span>
          </el-option>
        </el-select>
        <span class="text-danger" v-if="checkCenter">Chưa chọn chi nhánh !</span>
      </div>
    </div>
    <div class="mt-2" v-if="resetData">
      <el-radio v-model="radio1" :label="2">Chỉ làm bài test general</el-radio>
    </div>
    <div v-if="+radio1 === 2" :class="+radio1 === 2 ? 'col-span-2' : 'col-span-1'">
        <div>
            <el-select
                v-model="center_id"
                filterable class="w-100"
                placeholder="Chọn trung tâm"
                @change="handleOnlyGeneralCenterChange"
            >
                <el-option
                    v-for="item in centersTestInput"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                >
                    <span style="float: left">{{ item.name }}</span>
                </el-option>
            </el-select>
            <span class="text-danger" v-if="checkCenter">Chưa chọn chi nhánh !</span>
        </div>
        <div v-if="isOnlyGeneralMastery">
            <el-select
                clearable
                v-model="gradeLevel"
                filterable class="w-100"
                placeholder="Chọn giai đoạn học"
            >
                <el-option
                    v-for="item in gradeLevelOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                >
                    <span style="float: left">{{ item.label }}</span>
                </el-option>
            </el-select>
        </div>
    </div>
    <p class="mt-2" style="color: #FF0000; font-style: italic">Lưu ý: Nguồn lực admin test là có hạn. Vì vậy, chỉ đặt
      lịch test speaking khi chắc chắn lịch hẹn với khách hàng.</p>
    <div class="d-flex justify-content-end mt-6" v-if="!isCreateCustomer || radio1 === 0 || radio1 === 1 || (confirmOnlyGeneral && radio1 === 2)" >
      <el-button native-type="button" type="info" class="btn btn-secondary mr-2" :disabled="disabledSubmit" @click="cancel()">
        {{ isCreateCustomer ? 'Quay lại' : 'Hủy bỏ' }}
      </el-button>
      <button type="button" class="btn btn-primary" :disabled="radio1 === '' || loading || disabledSubmit" @click="confirmOption()">
        <i v-if="loading" class="el-icon-loading"></i>
        Xác nhận
      </button>
    </div>
  </div>
</template>
<script>
import {TOEIC} from "@/core/config/center/centerOption";
import {CENTER_LIST} from "@/core/services/store/customer/customer.module";
import {mapGetters} from "vuex";
import { Mentor_English_Mastery_ID } from "@/core/config/testInput/testInputOption";
import {GRADE_LEVEL_OPTIONS} from "@/core/config/testInput/learningOption";
import { isMasteryCenter } from "@/core/config/testInput/scheduleFieldOption";

export default {
  name: "OptionCreateTestInput",
    components: {},
    computed: {
        ...mapGetters(['currentUser', 'pilotAreaList']),
        isOnlyGeneralMastery() {
            return +this.radio1 === 2 && isMasteryCenter(this.center_id, Mentor_English_Mastery_ID);
        },
        isGradeLevelMissing() {
            // grade_level=0 (Chuẩn bị lên lớp 6) là giá trị hợp lệ → không dùng falsy check.
            return this.gradeLevel === '' || this.gradeLevel === null || this.gradeLevel === undefined;
        },
        disabledSubmit() {
            if (+this.radio1 === 2) {
                return !this.center_id || (this.isOnlyGeneralMastery && this.isGradeLevelMissing)
            }
            return false
        },
        showPilotAreaOption() {
            const branchId = this.currentUser && this.currentUser.profile ? +this.currentUser.profile.chi_nhanh_id : null;
            if ([217, 240, 328, 294, 238].includes(branchId)) {
                return true;
            }

            const areaId = this.currentUser && this.currentUser?.profile?.khuvuc_id ? +this.currentUser?.profile?.khuvuc_id : null;
            if (!areaId) {
                return false;
          }
          if (areaId == 7) {
              return true
            }

            return this.pilotAreaList.some(area => {
                   return +area.id === areaId;
            });
        }
    },
  props: {
    resetData: Boolean,
    isCreateCustomer:Boolean,
    confirmOnlyGeneral: Boolean,
    createScheduleAdvice: Number,
    // True khi lịch hiện tại đã đóng (Hủy lịch / Đã trả kết quả) → đang đặt lại mới.
    // Khi đó không chặn chọn lại Speaking-AI dù query param status còn sót giá trị cũ.
    isScheduleClosed: Boolean,
    // Parent bật cờ này khi người dùng chủ động đặt lại lịch Speaking-AI.
    allowSpeakingAi: Boolean
  },
  data() {
    return {
      radio1: '',
      loading: false,
      centersTestInput: [],
      center_id: null,
      checkCenter: false,
      status: this.$route.query.status,
      gradeLevelOptions: GRADE_LEVEL_OPTIONS,
      gradeLevel: '',
      branchIds: [213, 223, 251, 314, 261, 217, 266, 319, 247]
    }
  },
  watch: {
    radio1(newVal) {
      if (newVal) {
       this.$emit('changeButtonSave', true);
        this.checkCenter = false;
        this.gradeLevel = '';
      }
    },
    createScheduleAdvice(newVal) {
      if (newVal) {
        this.confirmOption();
      }
    },
    gradeLevel(newVal) {
        this.$emit('changeButtonSave', true);
        if (!this.confirmOnlyGeneral && newVal !== null && newVal !== undefined && newVal !== '') {
            this.confirmOption()
        }
    }
  },
  mounted() {
    this.getCenters()
  },
  methods: {
    cancel() {
      this.$emit('cancel')
    },
    handleOnlyGeneralCenterChange() {
      if (this.isOnlyGeneralMastery) {
        return;
      }
      this.gradeLevel = '';
    },
    confirmOption() {
      this.loading = true;
      if (this.radio1 == 3) {
         this.$emit('confirmOption', this.radio1)
      }
      if (this.radio1 && !this.center_id) {
        this.checkCenter = true;
        this.loading = false;
        return;
      }
      if (this.isOnlyGeneralMastery && this.isGradeLevelMissing) {
        this.loading = false;
        return;
      }
      if (this.status == 9 && !this.isScheduleClosed && !this.allowSpeakingAi) {
        this.$message({
          message: 'Bạn đã chọn nhu cầu test đầu vào này trước đó. Vui lòng chọn hình thức khác.',
          type: 'warning'
        });
        this.loading = false;
        return;
      }
      this.$emit(
          'confirmOption',
          this.radio1,
          this.center_id,
          this.isOnlyGeneralMastery ? this.gradeLevel : 1,
          this.isOnlyGeneralMastery ? {grade_level: this.gradeLevel} : {}
      )
    },
    getCenters() {
      this.$store.dispatch(CENTER_LIST)
          .then((response) => {
            if (response.status === 422) {
              this.$notify({
                title: 'Warning',
                message: `Serve đang bận, vui lòng thử lại sau: ${response.data.message}`,
                type: 'warning'
              });
            } else {
              this.centers = response.data;
              this.centersTestInput = response.data.filter(center => center.is_edutalk === 1 && center.id !== TOEIC);
            }
          });
    },
  }
}
</script>
<style scoped>
.col-span-1 {
    display: grid;
    grid-template-columns: 1fr;
}

.col-span-2 {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
}
</style>
